import { createTheme, type MantineColorsTuple } from "@mantine/core";

import { scriptAgnosticFilter } from "./i18n/searchFilter";

// Paleta: zelena oranica + zemljani akcenat (RS / Agencija za agrarna placanja)
const agri: MantineColorsTuple = [
  "#eef7ef", "#dcebde", "#b6d6bb", "#8dc095", "#6bad75", "#56a160", "#4a9a55", "#3b8645", "#30773b", "#1f5135",
];
const soil: MantineColorsTuple = [
  "#fbf3e9", "#f1e4d4", "#e3c6a6", "#d4a674", "#c88b4b", "#c17a31", "#be7124", "#a76018", "#955512", "#824708",
];

export const theme = createTheme({
  primaryColor: "agri",
  primaryShade: { light: 8, dark: 5 },
  colors: { agri, soil },
  // Manrope (latinica + ćirilica), lokalno iz paketa — radi i bez interneta na serveru
  fontFamily: "'Manrope Variable', 'Segoe UI', system-ui, -apple-system, Roboto, sans-serif",
  headings: { fontFamily: "'Manrope Variable', 'Segoe UI', system-ui, sans-serif", fontWeight: "750",
    sizes: { h2: { fontSize: "1.75rem", lineHeight: "1.2" }, h3: { fontSize: "1.45rem", lineHeight: "1.25" } } },
  defaultRadius: "md",
  other: { apple: "#c8453a", bark: "#7a5a3c", sage: "#eef3ec" },
  components: {
    Tabs: { defaultProps: { color: "agri" } },
    Button: { defaultProps: { radius: "md" } },
    Paper: { defaultProps: { radius: "md" } },
    // pretraga u listama radi i latinicom i ćirilicom (npr. „Куљ" pronalazi KO Kuljani)
    Select: { defaultProps: { filter: scriptAgnosticFilter } },
    MultiSelect: { defaultProps: { filter: scriptAgnosticFilter } },
    Autocomplete: { defaultProps: { filter: scriptAgnosticFilter } },
  },
});
